<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Total De HOE {{TitleTypeCCP}}</h1>
</div>


<!--&================= CONTAINER BAR NAVIGATION =================&-->

<div class="Options-Menu">

  <!---================= CONTAINER SELECT TYPE HOE =================--->

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-chart-simple"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Tipo de reporte</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input Inputng-Select">
          <i class="fa-regular fa-circle-question"></i>
          <ng-select [(ngModel)]="ValueTypeCCP" (change)="ChangeTypeCCP()" class="Custom-Form" [searchable]="false" [items]="OptionsTypeCCP"
            bindLabel="item" autofocus [clearable]="false" bindValue="value">
          </ng-select>
          <i class="fa-solid fa-angle-down"></i>
        </div>

      </div>

    </div>
  </div>


  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-layer-group"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Vista del reporte</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER GENERATE REPORT =================--->

        <div class="Container-Buttons">
          <div (click)="SeeReportList()" class="Btn-Option button-square">
            <span class="Tool-Tip">Reporte a nivel</span>
            <i class="fa-solid fa-chart-bar"></i>
          </div>
        </div>

      </div>

    </div>

  </div>

  <!---================= CONTAINER RELOAD PAGE =================--->

  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">

          <div (click)="ReloadPage()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </div>

        </div>

      </div>

    </div>

  </div>


  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-cloud-arrow-down"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Descargas</h2>
      </div>

      <div class="Input-Option DisplayInputs">

        <!---================= CONTAINER DOWNLOAD FILE =================--->
        <div class="Container-Buttons">

          <div (click)="DownloadReportXLSX()" class="Btn-Option XLSX button-square">
            <span class="Tool-Tip">Descargar Excel</span>
            <i class="fa-regular fa-file-excel"></i>
          </div>

          <div (click)="DownloadReportPDF()" class="Btn-Option PDF button-square">
            <span class="Tool-Tip">Descargar pdf</span>
            <i class="fa-regular fa-file-pdf"></i>
          </div>

        </div>
      </div>

    </div>

  </div>

</div>


<!--&================= CONTAINER SECTION REPORTS =================&-->
<div class="Container-Reports" id="Container-Reports">

  <!---================= CONTAINER SECTION FOLDERS =================--->
  <div class="container-global-components">
    <div class="Content-Struct">
      <div class="Top-Struct button-square">
        <h2>Total de HOE {{TitleTypeCCP}} por planta</h2>
      </div>

      <div class="Body-Struct">
        <div class="Container-Cards">

          <div *ngFor="let Folder of Folders_Nivel" class="Card-Struct">
            <div (click)="SeeFolder(Folder)" class="Content-Card">
              <div class="Total-Items button-square">
                {{Folder.ALL_Files}}
              </div>
              <div class="Title-Card">
                <h3>{{Folder.Name}}</h3>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div class="Bottom-Struct">
        <div class="Container button-square">
          <h2>TOTAL GENERAL</h2>
          <span>{{All_Files}}</span>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER SECTION CHART =================--->
  <div class="Container-Chart container-global-components">
    <!---================= CONTAINER SHOW ROUTE =================--->
    <div class="Route-Reports">
      <div class="Show-Route"><i class="fas fa-folder"></i><i class="fas fa-angle-right"></i>
        <div class="Route-Generator" *ngFor="let ruta of Header_Routes; let i=index">
          <span>{{ruta.split('§').pop()}}</span> <i class="fas fa-angle-right"></i>
        </div>
      </div>
      <div (click)="BackFolder()" *ngIf="Header_Routes.length>1" class="btnBack btn-icon">
        <i class="fa-solid fa-angles-left"></i>
      </div>
    </div>
    <div id="Pie_Chart"></div>
  </div>
</div>


<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>

<!---===================== MODAL FOR DOWNLOAD PROGRESS BAR REPORT PDF OR XLSX =====================--->
<section class="Modal-Global" id="ProgressModal">
  <div class="Content-DownloadTable">
    <div class="Tittle-Table">
      <h2>Descargando reporte ...</h2>
    </div>
    <div class="Body-Table">
      <div class="Container-progress-bar">
        <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
      </div>
    </div>
  </div>
</section>
